import React from 'react'
import styled from '@emotion/styled'
import { useAllMarkets } from '../services/GraphQlClientService'
import { gsColors } from '../styles/Variables'
import { mq } from '../helpers'

const MarketsListWrapper = styled.div`
  .markets-label {
    font-family: Euclid;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.38;
    letter-spacing: 1.2px;
    color: ${gsColors.black};
    margin: 0 0 18px 0;

    ${mq('max', '768px')} {
      font-size: 16px;
      letter-spacing: 0.96px;
    }
  }

  .markets-list {
    font-family: Euclid;
    font-size: 38px;
    font-weight: 400;
    line-height: 1.38;
    letter-spacing: 0.38px;
    color: ${gsColors.black};
    margin: 0;

    ${mq('max', '768px')} {
      font-size: 22px;
      letter-spacing: 0.22px;
    }
  }

  .markets-divider {
    color: ${gsColors.salmon};
  }
`

const MarketsList = () => {
  const markets = useAllMarkets()
  const names = (markets || []).filter((m) => m.isEnabled).map((m) => m.name)

  if (!names.length) {
    return null
  }

  return (
    <MarketsListWrapper aria-label="Markets we serve">
      <p className="markets-label">Our squad currently serves</p>
      <p className="markets-list">
        {names.map((name, i) => (
          <React.Fragment key={name}>
            {name}
            {i < names.length - 1 && <span className="markets-divider"> | </span>}
          </React.Fragment>
        ))}
      </p>
    </MarketsListWrapper>
  )
}

export default MarketsList
